<ng-container *ngIf="initialized && titles">
  <div style="display: none;">
    <gen-button [type]="'quite'" (click)="onClickAutomationButton()" [text]="'AutomationTesting-FATAL'"></gen-button>
    <gen-button [type]="'quite'" (click)="onClickAutomationIDB()" [text]="'AutomationTesting-IDB'"></gen-button>
    <gen-button [type]="'quite'" (click)="onClickAutomationWindowError()" [text]="'AutomationTesting-WindowError'"></gen-button>
  </div>

  <gen-user-counter-warning
      [name]="duplicatePatientsManager?.duplicatePatientName"
      [userId]="duplicatePatientsManager?.duplicatePatientId"
      [showDuplicatePatient]="showDuplicatePatientWarning"
      [proceedCallback]="duplicatePatientsManager?.duplicatePatientProceedCallback"
      [backCallback]="duplicatePatientsManager?.duplicatePatientBackCallback"
      [callbackObject]="duplicatePatientsManager"
      [params]="{name: duplicatePatientsManager?.duplicatePatientName, userId: duplicatePatientsManager?.duplicatePatientId}">
  </gen-user-counter-warning>

  <p-table #table class="override-ptable worklistContainer worklist-table-wrapper"
           (onRowSelect)="rowSelected($event,{data: $event.data, config: localConfig})"
           (onRowUnselect)="rowUnselected($event,{data: $event.data, config: localConfig})"
           (onHeaderCheckboxToggle)="selectAllRows($event)"
           (onSort)="onSort($event)"
           [paginator]="true"
           [pageLinks]=0
           [rowsPerPageOptions]="rowsPerPageOptions"
           [totalRecords]="totalRecords$ | async"
           [rows]="lastEvent.rows"
           [customSort]="true"
           [autoLayout]="true"
           [lazy]="true"
           [showCurrentPageReport]="false"
           [resetPageOnSort]="false"
           [responsive]="true"
           [rowTrackBy]="(hasTrackBy) ? rowTrackBy() : null"
           [sortField]="sortBy"
           [sortOrder]="sortOrder"
           [scrollable]="true"
           [value]="list"
           [(selection)]="selectedRows"
           [stateKey]="localConfig.tableStateEnabled ? stateKey : null"
  >
    <ng-template pTemplate="emptymessage">
      <tr *ngIf="!loading">
        <td [attr.colspan]="titles.length">
          {{'NO_RECORDS_TO_DISPLAY' | translate}}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="displayWorklistHeaderExport() && displayCheckableItems && canExportData" class="worklistHeaderCheckbox">
          <span *ngIf="exportDataConfig?.checkBoxName">{{exportDataConfig?.checkBoxName}}</span>
          <p-tableHeaderCheckbox *ngIf="visible" id="worklistHeaderCheckbox"
                                 [disabled]="exportDataConfig?.disabled || false">
          </p-tableHeaderCheckbox>
        </th>
        <th *ngFor="let item of titles; trackBy: titleTrackByFn; let i = index"
            class="{{item.width|lowercase}}-column-width {{item.className}}"
            genTooltip
            [ngClass]="{'table-header-action': item.type === 'actions'}"
            [tooltipHtml]="item?.tooltip"
            [appendToBody]="true"
            [tooltipPosition]=" item.tooltipPosition ? item.tooltipPosition: 'TOP' "
            [tooltipShow]="true"
            [pSortableColumn]="getSortColumn(item, sortKeys, i)">
          <span class="table-header-wrapper">
            <span class="{{item.icon}}"></span>
            <span>{{item.label|translate}}</span>
            <ng-container *ngIf="item.sortable && getSortColumn(item, sortKeys, i)">
              <p-sortIcon [field]="sortKeys[i]"></p-sortIcon>
            </ng-container>
          </span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      <tr #row [id]="rowData.id"  [pSelectableRow]="rowData" *ngIf="rowData && titles.length > 0 && conditionApplied(rowData)">
        <td *ngIf="displayCheckableItems && canExportData" class="worklistCheckbox">
          <p-tableCheckbox id="worklistCheckbox"
                           [value]="rowData"
                           [disabled]="exportDataConfig?.disabled || false">
          </p-tableCheckbox>
        </td>
        <td *ngFor="let item of titles; trackBy: titleTrackByFn;let i = index; let last = last"
            class="{{item.width|lowercase}}-column-width"
            (click)="rowClickedCallback($event ,{data: rowData, config: localConfig})">
          <section class="column-wrapper {{item.className}}">
            <!-- regular items -->
            <gen-worklist-item class="worklist-item column-data {{item.className}}"
                               *ngIf="hasTableListItem(last)"
                               [keys]="item.keys"
                               [searchText]="compactedSearchText"
                               [value]="{rowData: rowData, worklistType: resource}"
                               [practitionerType]="practitionerType"
                               (noteCompletedEmit)="updateNoteCompleted(rowData)"
                               [currentUserId]="currentUserId"
                               [executeActions]="executeActions">
            </gen-worklist-item>
            <!-- actions menu -->
            <gen-worklist-item class="column-actions"
                               *ngIf="hasTableListItemActions(last,rowData,i)"
                               [keys]="[{key: 'actions', type: 'actions', value: {}, resource: ''}]"
                               [value]="{rowData: rowData, worklistType: resource}"
                               [practitionerType]="practitionerType"
                               [trackByField]="trackByField"
                               [worklistActions]="worklistActions"
                               [disabledworklistActions]="disabledWorklistActions"
                               [mode]="mode"
                               [type]="resource"
                               [currentUserId]="currentUserId"
                               [checkActionsPermission] = "checkActionsPermission"
            >
            </gen-worklist-item>
          </section>
        </td>
      </tr>
    </ng-template >

    <ng-template pTemplate="footer" *ngIf="showFooter">
      <div class="footer-content">
        <div class="paginator-container">
          <p-paginator #customPaginator
                       [rows]="lastEvent.rows"
                       [templateLeft]="leftSide"
                       [templateRight]="rightSide"
                       [pageLinkSize]="0"
                       [rowsPerPageOptions]="rowsPerPageOptions"
                       [first]="lastEvent.first"
                       [totalRecords]="getBufferSize()"
                       (onPageChange)="paginate($event)">
          </p-paginator>

          <ng-template #leftSide>
            <div class="paginator-right">
              <span class="rows-per-page">Rows Per Page: &nbsp;</span>
              <p-dropdown *ngIf="customPaginator.rowsPerPageOptions"
                          styleClass="p-paginator-rpp-options p-row-dropdown"
                          [options]="customPaginator.rowsPerPageItems"
                          [(ngModel)]="customPaginator.rows"
                          (onChange)="customPaginator.onRppChange($event)"
                          [appendTo]="customPaginator.dropdownAppendTo"
                          [scrollHeight]="customPaginator.dropdownScrollHeight">
              </p-dropdown>
              <span class="test-count-info">
                <ng-container *ngIf="getBufferSize() as range">
                    Showing {{range}} items
                </ng-container>
              </span>
            </div>
          </ng-template>

          <ng-template #rightSide>
            <div class="paginator-left">
              <button type="button" pRipple class="p-paginator-first p-paginator-element p-link"
                      (click)="customPaginator.changePageToFirst($event)"
                      [ngClass]="{'p-disabled':customPaginator.isFirstPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-double-left"></span>
              </button>
              <button type="button" pRipple class="p-paginator-prev p-paginator-element p-link"
                      (click)="customPaginator.changePageToPrev($event)"
                      [ngClass]="{'p-disabled':customPaginator.isFirstPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-left"></span>
              </button>
              <span>Page &nbsp;</span>
              <p-inputNumber class="paginator-input"
                             mode="decimal"
                             (keydown)="goToPage($event)"
                             (onBlur)="goToPage($event)"
                             [(ngModel)]="currentPage"
                             [disabled]="customPaginator.getPageCount() <= 1 || loading"
                             [min]="1"
                             [max]="customPaginator.getPageCount()">
              </p-inputNumber>
              <span class="page-amount">&nbsp;of {{customPaginator.getPageCount()}}&nbsp;&nbsp;</span>
              <button type="button" pRipple class="p-paginator-next p-paginator-element p-link"
                      (click)="customPaginator.changePageToNext($event)"
                      [ngClass]="{'p-disabled':customPaginator.isLastPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-right"></span>
              </button>
              <button type="button" pRipple class="p-paginator-last p-paginator-element p-link"
                      (click)="customPaginator.changePageToLast($event)"
                      [ngClass]="{'p-disabled':customPaginator.isLastPage() || loading}">
                <span class="p-paginator-icon pi pi-angle-double-right"></span>
              </button>

            </div>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </p-table>
</ng-container>

<gen-overlay-loader *ngIf="loading || !initialized" [showOverlay]="true" class="worklist-table-loader"></gen-overlay-loader>


<ng-template #Loader>
    <gen-overlay-loader [showOverlay]="true"></gen-overlay-loader>
</ng-template>

<ng-container *ngIf="requesterConfig?.resource == 'ReportTemplate'">
    <gen-dynamic-modal-loader [observableName]="'ORGACCESS_POPUP_MODAL_CHANNEL'"></gen-dynamic-modal-loader>
</ng-container>
